import React from 'react';

import BaseForm from 'components/BaseForm/BaseForm';
import FiltersSubForms from 'components/FiltersSubForms';
import { useApi } from 'hooks/ApiStoreContext';

import { DashboardDSRFilterFormValues } from '../../../types';

import { FormFooter } from './FormFooter';

import './FormFooter/FormFooter.less';

interface DashboardDSRFilterFormProps {
  filter: Partial<DashboardDSRFilterFormValues>;
  setFilter: (value: Partial<DashboardDSRFilterFormValues>) => void;
}

function DashboardDSRFilterForm({
  filter,
  setFilter,
}: DashboardDSRFilterFormProps): React.ReactElement {
  const { ReferentielControllerApi: refController } = useApi();

  const subForms = FiltersSubForms(refController);

  return (
    <BaseForm
      initialValues={filter}
      subForms={[
        {
          title: 'Général',
          inputs: [
            subForms.statut,
            subForms.classement,
            subForms.fourriere,
            subForms.listUniteFo,
            subForms.statutsTraitementFacturation,
            subForms.includeDossiersAnonymises,
          ],
        },
        {
          title: 'Mise en fourrière',
          inputs: [
            subForms.natureMiseEnFourriere,
            subForms.dateRangeMiseEnFourriere,
          ],
        },
        {
          title: 'Suivi de mise en fourrière',
          inputs: [
            subForms.dateRangeOrdreDestruction,
            subForms.dateRangeBonEnlevement,
            subForms.dateRangeSortieDefinitive,
            subForms.motifDeSortie,
          ],
        },
      ]}
      onSubmit={() => Promise.resolve()}
      renderButtonAction={() => <FormFooter setFilter={setFilter} />}
    />
  );
}

export default DashboardDSRFilterForm;
